import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './config/mixins';
import './config/plugins';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import VueMask from 'v-mask';
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(VueMask);
Vue.use(CKEditor);
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
